// @flow

export const styles = {
  conatainer: {
    marginTop: 100,
    marginBottom: 100
  },
  padding: {
    padding: 40
  },
  highlightTitle: {
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '41px',
    color: '#2F3755'
  },
  paragraph: {
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 400,
    fontSize: 18,
    color: '#2F3755',
    lineHeight: '28px',
    '& > p': {
      margin: '0 0 40px 0'
    },
    '& > p:last-child': {
      margin: 0
    }
  },
  line: {
    width: 165,
    height: 5,
    marginBottom: 24,
    background: '#2F3755',
    borderRadius: 100
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/TextSection.Style.js